'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var throwErrorAsync = exports.throwErrorAsync = function throwErrorAsync(error) {
  setTimeout(function () {
    throw error;
  }, 0);
};